var _rect, _circle, _circle2, _circle3, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAngry16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.5,
    stroke: "#8292AB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 1,
    fill: "#8292AB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6,
    r: 1,
    fill: "#8292AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12C11.7761 12 12.0033 11.775 11.9692 11.501C11.7236 9.52736 10.0402 8 8 8C5.95985 8 4.27643 9.52736 4.03082 11.501C3.99672 11.775 4.22386 12 4.5 12C4.77614 12 4.99563 11.7745 5.04113 11.5021C5.2783 10.0822 6.51277 9 8 9C9.48723 9 10.7217 10.0822 10.9589 11.5021C11.0044 11.7745 11.2239 12 11.5 12Z",
    fill: "#8292AB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAngry16);
export default __webpack_public_path__ + "static/media/icon_angry_16.d8928766696fac1ec7003a0f9f407324.svg";
export { ForwardRef as ReactComponent };